// extracted by mini-css-extract-plugin
export var button = "cart-button-module--button--cddd7";
export var circle = "cart-button-module--circle--da1aa";
export var disabledLike = "cart-button-module--disabled-like--7082b";
export var fullButton = "cart-button-module--full-button--f9dac";
export var icon = "cart-button-module--icon--ca853";
export var iconBox = "cart-button-module--icon-box--f66f0";
export var normalButton = "cart-button-module--normal-button--9aba9";
export var text = "cart-button-module--text--1c4ee";
export var transitionButton = "cart-button-module--transition-button--0d941";